import { DownOutlined } from '@ant-design/icons';
import { Dropdown, Layout, Menu } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { logout } from '../../actions/auth';
import logo from '../../assets/image/logo_1000px.png';
import { PRODUCT_TYPE_CHOICE_KEY } from '../../constants/order';
import { RootState } from '../../reducers';
import { IAuthState } from '../../reducers/auth';
import { $primary } from '../../styles/Variables';

import StoreSwitcher from '../Store/StoreSwitcher';

const { Header } = Layout;

const CustomHeader = styled(Header)`
  /* border-bottom: 1px solid ${$primary}; */
  /* border: 1px 0 solid #eaecf0; */
  z-index: 1000;
  /* background-color: #131921; */

  &.ant-layout {
    min-height: 100vh;
  }

  &.ant-layout-header {
    background-color: #fff;
    display: grid;
    grid-template-columns: 259px auto;
    padding: 0 24px;
    height: 62px;
    line-height: unset;
    padding-inline: 0;
  }

  .logo {
    width: 120px;
    height: 31px;
  }
`;

const LogoContainer = styled.div`
  display: grid;
  justify-content: start;
  align-items: center;
  padding: 0 20px;

  .logo {
    width: 120px;
    height: 31px;
  }
`;

const ProfileWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  border-left: 1px solid var(--color-border);
  padding: 0 20px;
`;

// eslint-disable-next-line
enum MenuAdminActions {
  LOGOUT = 'LOGOUT',
  CLEAR_PRODUCT_TYPE_CHOICE = 'CLEAR_PRODUCT_TYPE_CHOICE',
}

const MainHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { currentUser } = useSelector(
    (state: RootState) => state.auth as IAuthState
  );

  const logoutAction = async () => {
    dispatch(logout(() => navigate('/login')));
  };

  const clearChoice = () => {
    localStorage.removeItem(PRODUCT_TYPE_CHOICE_KEY);
  };

  const handleMenuClick = (e: any) => {
    switch (e.key) {
      case MenuAdminActions.LOGOUT:
        logoutAction();
        return;
      case MenuAdminActions.CLEAR_PRODUCT_TYPE_CHOICE:
        clearChoice();
        return;
      default:
        return;
    }
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key={MenuAdminActions.LOGOUT}>Logout</Menu.Item>
      <Menu.Item key={MenuAdminActions.CLEAR_PRODUCT_TYPE_CHOICE}>
        Clear Order Choice
      </Menu.Item>
    </Menu>
  );

  return (
    <CustomHeader>
      <LogoContainer>
        <img src={logo} alt="Logo" width={120} />
      </LogoContainer>
      {currentUser && (
        <ProfileWrapper>
          <StoreSwitcher />
          <Dropdown className="text-black" overlay={menu} trigger={['click']}>
            <a
              className="ant-dropdown-link"
              onClick={(e) => e.preventDefault()}
            >
              {`${currentUser.role.toLocaleUpperCase()}: ${
                currentUser.username
              }`}
              <DownOutlined className="m__l--8" />
            </a>
          </Dropdown>
        </ProfileWrapper>
      )}
    </CustomHeader>
  );
};
export default MainHeader;
